export default {"src":"/_next/static/media/cherry-logo-long.17321f91.svg","height":32,"width":94,"blurWidth":0,"blurHeight":0};